<template>
  <div class="order-discounts-container">
    <div class="margin-top">
      <el-table :data="aOrderDetailDiscountsInfo.discounts" border style="width: 100%" v-loading="loading">
        <el-table-column type="index" :label="$t('aOrderDetailDiscounts.serial')" align="center" width="80">
        </el-table-column>
        <el-table-column prop="discountTypeName" :label="$t('aOrderDetailDiscounts.discountType')" align="center"
          width="150">
        </el-table-column>
        <el-table-column :label="$t('aOrderDetailDiscounts.discountAmount')" align="center" width="180">
          <template slot-scope="scope">
            <span v-if="scope.row.discountType == '2002'">
              {{ scope.row.discountPrice }}
            </span>
            <span v-else>
              {{ scope.row.discountPrice }}({{ scope.row.discountRate }})
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" :label="$t('aOrderDetailDiscounts.description')" align="center" width="200">
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('aOrderDetailDiscounts.time')" align="center" width="180">
        </el-table-column>
      </el-table>

      <el-row class="margin-top">
        <el-col :span="24" class="text-right">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="pagination.currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
          </el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getOrderDiscounts } from '@/api/order/aOrderDetailApi'

export default {
  name: 'AOrderDetailDiscounts',
  data() {
    return {
      aOrderDetailDiscountsInfo: {
        discounts: [],
        orderId: '',
        prodNameLike: '',
        personNameLike: ''
      },
      loading: false,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  methods: {
    open(params) {
      this.aOrderDetailDiscountsInfo.orderId = params.orderId
      this.loadOrderDiscountsData()
    },
    loadOrderDiscountsData() {
      this.loading = true
      const params = {
        orderId: this.aOrderDetailDiscountsInfo.orderId,
        page: this.pagination.currentPage,
        row: this.pagination.pageSize
      }

      getOrderDiscounts(params).then(response => {
        this.aOrderDetailDiscountsInfo.discounts = response.data
        this.pagination.total = response.records
        this.loading = false
      }).catch(error => {
        console.error('获取订单优惠失败:', error)
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadOrderDiscountsData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadOrderDiscountsData()
    }
  }
}
</script>

<style scoped>
.order-discounts-container {
  padding: 15px;
}

.margin-top {
  margin-top: 15px;
}

.text-right {
  text-align: right;
}
</style>